import {Component, Input, OnInit} from '@angular/core';
import {SmartModalService} from '../../../../services/smart-modal.service';
import {CertificateService} from '../certificate.service';
import {RxComponent} from '../../../../../shared/components/common/rx.component';

@Component({
  selector: 'itpx-certificate-preview',
  templateUrl: './certificate-preview.component.html',
  styleUrls: ['./certificate-preview.component.css']
})
export class CertificatePreviewComponent extends RxComponent implements OnInit {

  @Input()
  private data: any;

  constructor(private modalService: SmartModalService,
              private certificateService: CertificateService) {
    super();
  }

  ngOnInit() {
    this.loadIframe();
  }

  private loadIframe() {
    if (this.data.text != null) {
      let iframeDocument = document.querySelector('#certificate-holder')['contentWindow'].document;
      iframeDocument.open('text/html', 'replace');
      iframeDocument.write(this.data.text);
      iframeDocument.close();
    }
  }

  private onClick() {
    if (!this.data.eLearning) {
      this.certificateService.getCertificateDownloadLink(this.data.previewCert)
        .map(body => body.data)
        .subscribe(data => {
          this.certificateService.getCertificateFile(data.certLocation)
            .subscribe();
        });
    }else{
      this.certificateService.getElearningCertificateDownloadLink(this.data.id)
        .map(body => body.data)
        .subscribe(data => {
          this.certificateService.getCertificateFile(data.certLocation)
            .subscribe();
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/certificate/preview/certificate-preview.component.ts